import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-geography',
  templateUrl: './geography.component.html',
  styleUrls: ['./geography.component.scss']
})
export class GeographyComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
